<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Modal" pageTitle="Modal" />
            <ModalContant />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import ModalContant from '../Modal/ModalContant'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'ModalPage',
    components: {
        MainHeader,
        PageTitle,
        ModalContant,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>